import { residentUsers } from "@/mocks/users";

export default function ResidentStats() {
  const total = residentUsers.length;
  const normal = residentUsers.filter(u => u.status === "正常").length;
  const arrears = residentUsers.filter(u => u.status === "欠费预警").length;
  const stopped = residentUsers.filter(u => u.status === "停气").length;
  const avgBalance = residentUsers.reduce((s, u) => s + u.balance, 0) / total;

  return (
    <div className="grid grid-cols-5 gap-3">
      {[
        { label: "居民用户总数", value: total, icon: "ri-user-3-line", color: "text-gray-800", bg: "bg-gray-50", sub: "已建档用户" },
        { label: "正常用户", value: normal, icon: "ri-checkbox-circle-line", color: "text-green-600", bg: "bg-green-50", sub: `占比 ${Math.round(normal/total*100)}%` },
        { label: "欠费预警", value: arrears, icon: "ri-error-warning-line", color: "text-amber-600", bg: "bg-amber-50", sub: "需及时处理" },
        { label: "已停气", value: stopped, icon: "ri-close-circle-line", color: "text-red-600", bg: "bg-red-50", sub: "待恢复供气" },
        { label: "平均余额", value: `¥${avgBalance.toFixed(0)}`, icon: "ri-wallet-3-line", color: "text-[#E8531A]", bg: "bg-orange-50", sub: "账户平均余额" },
      ].map((s, i) => (
        <div key={i} className={`${s.bg} rounded-xl p-4`}>
          <div className="flex items-center justify-between mb-2">
            <div className={`w-8 h-8 flex items-center justify-center rounded-lg bg-white`}>
              <i className={`${s.icon} ${s.color} text-base`}></i>
            </div>
          </div>
          <div className={`text-2xl font-bold ${s.color}`}>{s.value}</div>
          <div className="text-xs font-medium text-gray-700 mt-0.5">{s.label}</div>
          <div className="text-[10px] text-gray-400 mt-0.5">{s.sub}</div>
        </div>
      ))}
    </div>
  );
}
